import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function FooterSystem() {
  const [isLinksExpanded, setIsLinksExpanded] = useState(false);

  const DesktopLinks = () => (
    <>
      <Link to="/login" className="hover:text-white text-sm">Login</Link>
      <Link to="/system/faqs" className="hover:text-white text-sm">Help & Support</Link>
      <Link to="/system/privacy-policy" className="hover:text-white text-sm">Privacy Policy</Link>
      <Link to="/system/terms-conditions" className="hover:text-white text-sm">Terms & Conditions</Link>
      <Link to="/system/refund-policy" className="hover:text-white text-sm">Refund Policy</Link>
      <Link to="/system/affiliates" className="hover:text-white text-sm">Affiliates</Link>
    </>
  );

  const MobileLinks = () => (
    <div className="flex flex-col space-y-4 mb-6">
      <Link to="/login" className="block hover:text-white text-sm">Login</Link>
      <Link to="/system/faqs" className="block hover:text-white text-sm">Help & Support</Link>
      <Link to="/system/privacy-policy" className="block hover:text-white text-sm">Privacy Policy</Link>
      <Link to="/system/terms-conditions" className="block hover:text-white text-sm">Terms & Conditions</Link>
      <Link to="/system/refund-policy" className="block hover:text-white text-sm">Refund Policy</Link>
      <Link to="/system/affiliates" className="block hover:text-white text-sm">Affiliates</Link>
    </div>
  );

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Desktop Footer */}
      <div className="hidden sm:block">
        <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <Link to="/">
              <img
                src="/HRO-Logo-transparent-white-logo-white-text.png"
                alt="Horse Racing Oracle"
                className="h-10"
              />
            </Link>
          </div>

          {/* Policy Links */}
          <div className="flex justify-center space-x-8 mb-8">
            <DesktopLinks />
          </div>

          {/* Divider */}
          <div className="border-t border-gray-700 max-w-4xl mx-auto mb-8"></div>

          {/* Responsible Gambling Disclaimer */}
          <div className="text-center mb-8 max-w-3xl mx-auto">
            <p className="text-sm">
              <b>IMPORTANT:</b> Gambling involves risk and you must not gamble with funds you can't afford to lose. 
              It is not a solution to any financial difficulties. Please gamble responsibly and 
              only bet what you can afford. If you or someone you know has a gambling problem, 
              please seek help.
            </p>
            <p className="text-sm mt-4">
              ClickBank is the retailer of products on this site. CLICKBANK® is a registered trademark 
              of Click Sales, Inc., a Delaware corporation located at 1444 S. Entertainment Ave., 
              Suite 410 Boise, ID 83709, USA and used by permission. ClickBank's role as retailer 
              does not constitute an endorsement, approval or review of these products or any claim, 
              statement or opinion used in promotion of these products.
            </p>
            <div className="mt-4 text-sm">
              <p>
                For Product Support, please contact us{' '}
                <Link to="/system/contact" className="text-primary-600 hover:text-primary-500">HERE</Link>
              </p>
              <p>
                For Order Support, please contact ClickBank{' '}
                <a href="http://www.clkbank.com/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-500">HERE</a>
              </p>
            </div>
          </div>

          {/* Support Organizations */}
          <div className="flex justify-center items-center space-x-6">
            <div className="hover:opacity-75">
              <img
                src="/gambling-support/18+.png"
                alt="18+ Only"
                className="h-8"
              />
            </div>
            <a
              href="https://www.begambleaware.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-75"
            >
              <img
                src="/gambling-support/begambleaware.png"
                alt="BeGambleAware"
                className="h-8"
              />
            </a>
            <a
              href="https://www.gamstop.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-75"
            >
              <img
                src="/gambling-support/gamstop.png"
                alt="GamStop"
                className="h-8"
              />
            </a>
            <a
              href="https://www.taketimetothink.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-75"
            >
              <img
                src="/gambling-support/take-time.png"
                alt="Take Time to Think"
                className="h-8"
              />
            </a>
            <a
              href="tel:08088020133"
              className="hover:opacity-75"
            >
              <img
                src="/gambling-support/national-gambling-helpline.png"
                alt="National Gambling Helpline - Call 0808 8020 133"
                className="h-8"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Footer */}
      <div className="block sm:hidden">
        <div className="px-4 py-6">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <Link to="/">
              <img
                src="/HRO-Logo-transparent-white-logo-white-text.png"
                alt="Horse Racing Oracle"
                className="h-8"
              />
            </Link>
          </div>

          {/* Collapsible Links Section */}
          <div className="mb-6 border-b border-gray-700">
            <button
              onClick={() => setIsLinksExpanded(!isLinksExpanded)}
              className="w-full flex justify-between items-center py-3 text-sm font-medium hover:text-white"
            >
              Useful Links
              <svg
                className={`h-5 w-5 transform transition-transform duration-200 ${
                  isLinksExpanded ? 'rotate-180' : ''
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div className={`overflow-hidden transition-all duration-200 ${
              isLinksExpanded ? 'max-h-96' : 'max-h-0'
            }`}>
              <div className="py-3 pl-4">
                <MobileLinks />
              </div>
            </div>
          </div>

          {/* Responsible Gambling Disclaimer */}
          <div className="mb-6">
            <p className="text-sm">
              <b>IMPORTANT:</b> Gambling involves risk and you must not gamble with funds you can't afford to lose. 
              It is not a solution to any financial difficulties. Please gamble responsibly and 
              only bet what you can afford. If you or someone you know has a gambling problem, 
              please seek help.
            </p>
            <p className="text-sm mt-4">
              ClickBank is the retailer of products on this site. CLICKBANK® is a registered trademark 
              of Click Sales, Inc., a Delaware corporation located at 1444 S. Entertainment Ave., 
              Suite 410 Boise, ID 83709, USA and used by permission. ClickBank's role as retailer 
              does not constitute an endorsement, approval or review of these products or any claim, 
              statement or opinion used in promotion of these products.
            </p>
            <div className="mt-4 text-sm">
              <p>
                For Product Support, please contact us{' '}
                <Link to="/system/contact" className="text-primary-600 hover:text-primary-500">HERE</Link>
              </p>
              <p>
                For Order Support, please contact ClickBank{' '}
                <a href="http://www.clkbank.com/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-500">HERE</a>
              </p>
            </div>
          </div>

          {/* Support Organizations */}
          <div className="grid grid-cols-3 gap-4 justify-items-center">
            <div className="hover:opacity-75">
              <img
                src="/gambling-support/18+.png"
                alt="18+ Only"
                className="h-8"
              />
            </div>
            <a
              href="https://www.begambleaware.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-75"
            >
              <img
                src="/gambling-support/begambleaware.png"
                alt="BeGambleAware"
                className="h-8"
              />
            </a>
            <a
              href="https://www.gamstop.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-75"
            >
              <img
                src="/gambling-support/gamstop.png"
                alt="GamStop"
                className="h-8"
              />
            </a>
            <a
              href="https://www.taketimetothink.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-75"
            >
              <img
                src="/gambling-support/take-time.png"
                alt="Take Time to Think"
                className="h-8"
              />
            </a>
            <a
              href="tel:08088020133"
              className="hover:opacity-75 col-span-2"
            >
              <img
                src="/gambling-support/national-gambling-helpline.png"
                alt="National Gambling Helpline - Call 0808 8020 133"
                className="h-8"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
} 